import {
  SEARCH_PLAYERS_BY_PARAMS_BEGIN, SEARCH_PLAYERS_BY_PARAMS_SUCCESS, SEARCH_PLAYERS_BY_PARAMS_FAILURE} from '../constants/action-types';

import {BASE_URL, API_URLS} from '../constants/config'
import axios from 'axios';
import {refreshTokens, logOut} from './usersActions'
import {checkIfTokenExpired, getTokensFromStore } from '../utilities/tokens'
let token;

export const searchPlayersBegin = () => ({
  type: SEARCH_PLAYERS_BY_PARAMS_BEGIN
});

export const searchPlayersSuccess = players => ({
  type: SEARCH_PLAYERS_BY_PARAMS_SUCCESS,
  payload: { players }
});

export const searchPlayersFailure = error => ({
  type: SEARCH_PLAYERS_BY_PARAMS_FAILURE,
  payload: { error }
});


export function searchPlayers(url, params, offset, limit) {
  return dispatch => {
    dispatch(searchPlayersBegin());
    return axios.post(BASE_URL.url + url,{
      name: params.name,
      family: params.family,
      father_name: params.father_name,
      offset,
      limit
    }, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    }).then(res => {
      dispatch(searchPlayersSuccess(res));
      return res;
    }).catch((error) => {
      dispatch(searchPlayersFailure(error.response))
    });
  };
}
// Заявки игрока (extra_team_applications): команда, название заявки, год.
// Нужны, чтобы при проверке на дубли показать админу, где уже заявлен однофамилец.
export function fetchPlayerAdminApplications(playerId) {
  return async dispatch => {
    if (checkIfTokenExpired()) {
      await dispatch(refreshTokens())
    }
    const tokens = getTokensFromStore();
    return axios.get(`${BASE_URL.url}/players/${playerId}/adminApplications`, {
      headers: {
        "Authorization": "Bearer " + tokens.access_token,
        Accept: 'application/json',
      }
    }).then(res => {
      const rows = (res.data && res.data.data) || res.data || [];
      return Array.isArray(rows) ? rows : [];
    }).catch((error) => {
      if (error.response && error.response.status === 401) {
        dispatch(logOut())
      }
      throw error;
    });
  };
}

// Тот же поиск, что searchPlayers, но без записи в redux-стор: проверка на дубли
// гоняет его десятки раз и не должна перетирать выдачу других страниц
// (например, «Чёрного списка», который читает state.player.searchPlayers)
export function findPlayersByName(params, offset, limit) {
  return () => axios.post(BASE_URL.url + API_URLS.searchPlayersByParams, {
    name: params.name,
    family: params.family,
    father_name: params.father_name,
    offset,
    limit
  }, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
  });
}

// Один запрос вместо N × search + adminApplications (FRONTEND_API_CHANGES §2.2)
export function findPlayerDuplicates({ applicationId, teamId, players }) {
  return async dispatch => {
    if (checkIfTokenExpired()) {
      await dispatch(refreshTokens());
    }
    const tokens = getTokensFromStore();
    return axios.post(BASE_URL.url + API_URLS.findPlayerDuplicates, {
      application_id: applicationId || null,
      team_id: teamId || null,
      players,
    }, {
      headers: {
        "Authorization": "Bearer " + tokens.access_token,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(res => {
      const rows = (res.data && res.data.data) || res.data || [];
      return Array.isArray(rows) ? rows : [];
    }).catch((error) => {
      if (error.response && error.response.status === 401) {
        dispatch(logOut());
      }
      throw error;
    });
  };
}
